module.exports = "/_next/static/images/930272296a155dbbc2c48614fd20f808-woman-using-cellphone@0.5x.jpg.webp";